import React, { lazy, Suspense, useEffect } from "react";
import "./Dashboard.css";
import { getUserRolesById } from "../../../../../config/Services";

// Lazy loaded components
const RetailDashboardPage = lazy(() => import("./Pages/RetailDashboardPage/RetailDashboardPage"));

const RestaurantDashboardPage = lazy(() =>
  import("./Pages/RestaurantDashboardPage/RestaurantDashboardPage")
);

// Loading component with enhanced UI
const LoadingFallback = () => {
  const retailType = localStorage.getItem("retailType");
  const isGrocery = retailType === "GROCERY";

  return (
    <div className="hdv2-loading-root">
      <div className="hdv2-loading-container">
        <div className="hdv2-loading-spinner"></div>
        <div className="hdv2-loading-content">
          <h2 className="hdv2-loading-title">
            Loading {isGrocery ? "Grocery" : "Restaurant"} Dashboard
          </h2>
          <p className="hdv2-loading-message">Please wait while we prepare your dashboard...</p>
          <div className="hdv2-loading-progress">
            <div className="hdv2-loading-progress-bar"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

const Dashboard = () => {
  const retailType = localStorage.getItem("retailType");
  const locId = localStorage.getItem("locId");
  const orgId = localStorage.getItem("orgId");
  const retailUserDetails = JSON.parse(localStorage.getItem("retailUserDetails"));
  const userId = retailUserDetails?.uidx;

  useEffect(() => {
    if (!localStorage.getItem("loggedInCount")) {
      localStorage.setItem("loggedInCount", 0);
    }

    const getUserRolesByIdFun = async () => {
      const res = await getUserRolesById(userId, orgId, locId);

      const roles = res?.data?.data?.roles || [];

      localStorage.setItem("user_roles", JSON.stringify(roles));
    };

    getUserRolesByIdFun();
  }, []);

  useEffect(() => {
    window.history.pushState(null, "", window.location.href);

    const handlePopState = () => {
      window.history.pushState(null, "", window.location.href);
    };

    window.addEventListener("popstate", handlePopState);
    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, []);

  return (
    <Suspense fallback={<LoadingFallback />}>
      {retailType === "GROCERY" ? <RetailDashboardPage /> : <RestaurantDashboardPage />}\{" "}
    </Suspense>
  );
};

export default Dashboard;
